import React from "react";
import { Link, useLocation } from 'react-router-dom';
import CloseIcon from "../icons/CloseIcon";

const ForgotPasswordMailPage = () => { 
    const location = useLocation();
    const params   = new URLSearchParams(location.search);
    const email    = params.get("email");

    return (
        <section className="account py-40">           
            <div className="container container-lg">            
                <div className="row gy-4">                   
                    <div className="col-xl-3"></div>
                    <div className="col-xl-5">
                        <div className="row gy-4">
                            <div className="col-xl-6">
                                <div className="logo px-16 d-block">
                                    <Link to='/' className='mobile-menu__logo'>
                                        <img src='../../assets/images/logo/dhofar-logo.svg' alt='Logo' />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-xl-6 d-flex justify-content-end align-items-center">
                                <Link to='/'>
                                    <CloseIcon size={14} className='text-neutral-900' />
                                </Link>
                            </div>
                        </div>                        
                        <div className="product-dContent border rounded-24 p-20 mt-30"> 
                            <div className="mb-40">   
                                <div className="mb-24">
                                    <h4 className="text-left"><b>Check your email</b></h4> 
                                    <div className="pt-20 pb-20">We have sent a password reset link to {email}</div>
                                </div>                                    
                            </div>    
                        </div>                         
                    </div>                    
                </div>
            </div>                    
        </section>
    );
};

export default ForgotPasswordMailPage;
